import {
  AsyncStream
} from "./chunk-SGBCNXYH.mjs";

// src/client.ts
var ApiError = class extends Error {
  constructor(statusCode, method, message) {
    super(message);
    this.statusCode = statusCode;
    this.method = method;
    this.name = "ApiError";
  }
};
var ProxyApiClient = class {
  constructor(_request) {
    this._request = _request;
  }
  _createProxy(prefix) {
    return new Proxy(() => {
    }, {
      apply: async (_target, _self, args) => {
        const result = await this._request(prefix, args[0]);
        return result;
      },
      get: (_target, prop) => {
        if (typeof prop === "symbol") {
          return void 0;
        }
        if (prop === "then" || prop === "catch" || prop === "finally" || prop === "toString" || prop === "valueOf" || prop === "toJSON" || prop === "name" || prop === "length" || prop === "prototype" || prop === "constructor" || prop === "caller" || prop === "arguments") {
          return void 0;
        }
        return this._createProxy(`${prefix}${prefix ? "/" : ""}${prop}`);
      }
    });
  }
  methods = this._createProxy("");
};
function createFetchClient(baseUrl, options) {
  return new ProxyApiClient(async (method, arg) => {
    const result = await fetch(`${baseUrl}/${method}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...options?.getHeaders?.()
      },
      body: JSON.stringify(arg)
    });
    if (result.status !== 200) {
      const data2 = await result.json().catch(() => null);
      let message;
      if (data2 && typeof data2 === "object" && ("errorMessage" in data2 || "error" in data2)) {
        const msg = data2.errorMessage ?? data2.error;
        const stack = data2.stack;
        message = `${msg}${stack ? `
${stack}` : ""}`;
      } else {
        message = `Error calling API method "${method}" (${result.status}): ${JSON.stringify(data2)}`;
      }
      const error = new ApiError(result.status, method, message);
      options?.onError?.(error);
      throw error;
    }
    const contentType = result.headers.get("Content-Type");
    if (contentType?.startsWith("application/jsonl")) {
      return AsyncStream.fromFn(async function* () {
        const reader = result.body?.getReader();
        if (!reader) {
          return;
        }
        let buffer = "";
        const decoder = new TextDecoder("utf-8");
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            break;
          }
          buffer += decoder.decode(value, { stream: true });
          let eolIndex;
          while ((eolIndex = buffer.indexOf("\n")) >= 0) {
            const line = buffer.slice(0, eolIndex).trim();
            buffer = buffer.slice(eolIndex + 1);
            if (line.length > 0) {
              yield JSON.parse(line);
            }
          }
        }
        const finalLine = buffer.trim();
        if (finalLine.length > 0) {
          yield JSON.parse(finalLine);
        }
      });
    }
    const data = await result.json();
    return data;
  });
}
function createLocalClient(api, context) {
  return new ProxyApiClient(async (method, args) => {
    return await api.run(method, args, context);
  });
}

export {
  ApiError,
  ProxyApiClient,
  createFetchClient,
  createLocalClient
};
//# sourceMappingURL=chunk-TAEFVNPN.mjs.map